import axios from 'axios';
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import BasicInformation from "../../components/patient-timeline/basic-information"
import { successToast, errorToast } from "../../components/toastmessage/toastmessage";
import { useNavigate } from 'react-router-dom';

const BasicInfo = () => {
  const navigate = useNavigate();

  const submitBasicInfo = (event, value , patientId) => {
    event.preventDefault();
   axios.post("https://arogyanxtdevapi.fundaclear.in/api/v1/Patient",{basicDetail: value}).then((res) =>{
      if(res?.status === 200){
        let rowData = {
          uniqueID: patientId
        }
        navigate("/patient-registration", { state: { addPatient: false , rowData:rowData} })
        successToast(res?.data?.message);
      }
    }).catch((err) =>{
      errorToast(err?.response?.data?.error)
    })
  }
  
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <BasicInformation  submitBasicInfo={submitBasicInfo} />
      </div>
    </div>
  )
}

export default BasicInfo;
